import { render } from "./ConfiguracoesEdit.vue?vue&type=template&id=7fcee745"
import script from "./ConfiguracoesEdit.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesEdit.vue?vue&type=script&lang=js"

import "./ConfiguracoesEdit.vue?vue&type=style&index=0&id=7fcee745&lang=css"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__